/* Baci Service 5 — S6: LYERJA (12 shtator 2026).
   Regjistrohet te window.BaciServiceRules; kontrata: fn(t, lang, raw) → html | {html, only:true} | null.
   Kthen gjithmone { only: true } kur e kap temen, sepse "sa zgjat lyerja" dhe "sa kushton" ndryshe
   bien te S2 (afati i dergeses) — S6 duhet ta zevendesoje.

   Faktet: B0 (cilat pjese lyhen), B2 (kodi te korniza e deres se DJATHTE te perparme, 3–6 foto,
   ekipi ne telefon), B3 (50% paradhenie, 50% kur e merr), B4 (pas lyerjes pa kthim as nderrim).
   Cmimet: metafield-e produkti bajrami.lyerja_standarde / lyerja_perla / lyerja_afati, te vendosura
   nga pronari me 12 shtator 2026 per 217 produkte. Shifra e sakte del te vete pjesa (paint ne JSON);
   ketu jepen vetem brezat e verteta te llogaritura nga ato te dhena:
     parakolp para  p25–p75 = 250–350 €   (mesatarja 280)
     parakolp mbrapa p25–p75 = 200–350 €  (mesatarja 260)
     body kit        p25–p75 = 450–800 €
     conversion set  p25–p75 = 750–1200 €
   Perla: +60 € te parakolpet, +100 € te body kitet dhe conversion set-et (rregull i pronarit).
   Afati: parakolp 2–3 dite, body kit / conversion set 3–5 dite — DUKE FILLUAR kur konfirmohet
   kodi i ngjyres dhe merret 50% paradhenia, jo nga porosia. Kjo thuhet gjithmone bashke me afatin.
   NUK LYHEN (vijne gati ne black gloss): difuzor, spojler, lip, splitter, grill, prag, aero kit.
*/
(function () {
  var U = window.BaciServiceUtil;
  if (!U) return;
  var any = U.any, waLink = U.waLink;

  var PAINT = ['lyerje', 'lyerja', 'lyerjen', 'lyerjes', 'lyeni', 'lyej', 'lyer', 'lyera', 'lyhet', 'lyhen', 'lyej',
    'ngjyros', 'ngjyrose', 'ngjyrosje', 'ngjyrosur', 'ngjyra', 'ngjyre', 'ngjyren', 'ngjyres', 'ngjyrave', 'boje', 'bojen', 'bojra',
    'paint', 'painting', 'painted', 'respray', 'sprayed', 'colour', 'color',
    'lackieren', 'lackierung', 'lackiert', 'lack', 'farbe', 'farbton', 'farbcode'];
  var CODE = ['kodi', 'kodin', 'kodit', 'kod', 'paint code', 'color code', 'colour code', 'farbcode', 'code'];
  var PEARL = ['perla', 'perle', 'perl', 'pearl', 'perlmutt', 'perleffekt', 'sedef'];
  var PRICE = ['sa kushton', 'sa bon', 'sa eshte', 'sa i bjen', 'cmimi', 'cmim', 'qmimi', 'kushton',
    'how much', 'what does it cost', 'cost', 'price', 'was kostet', 'preis', 'kosten'];
  var TIME = ['sa zgjat', 'sa dite', 'sa kohe', 'afati', 'afatin', 'kur eshte gati', 'kur behet',
    'how long', 'how many days', 'lead time', 'wie lange', 'dauert', 'wann fertig'];
  var COMES = ['a vjen e lyer', 'vjen e lyer', 'a vjen lyer', 'eshte e lyer', 'a eshte e lyer',
    'comes painted', 'already painted', 'is it painted', 'kommt lackiert', 'ist es lackiert', 'schon lackiert'];
  var GLOSS = ['difuzor', 'difuzori', 'difuzorin', 'difuzoret', 'difuzori', 'diffuser', 'diffusers', 'diffusor',
    'spojler', 'spojleri', 'spojlerin', 'spojlerat', 'spojlera', 'spoiler', 'spoilers', 'heckspoiler',
    'lip', 'lipa', 'lipi', 'lipin', 'lipat', 'frontlip', 'front lip', 'splitter', 'splitteri', 'splitterin',
    'grill', 'grilla', 'grilli', 'grillin', 'grillat', 'kuhlergrill', 'grille',
    'prag', 'pragu', 'pragun', 'pragjet', 'pragje', 'side skirt', 'side skirts', 'skirts',
    'seitenschweller', 'aero kit', 'aerokit',
    'difuzorit', 'spojlerit', 'spoilerit', 'lipit', 'splitterit', 'grillit', 'pragut', 'pragjeve'];

  var T = {
    sq: {
      how: 'Lyerja bëhet te ne, sipas <b>kodit të ngjyrës së fabrikës</b> — jo me sy.',
      code: 'Kodi është te letra ngjitëse në kornizën e <b>derës së djathtë të përparme</b> (ana e pasagjerit) — 2–4 shenja, p.sh. 475/9, LY9B, 197. Nëse s\'e gjen, dërgo 3–6 foto në dritë natyrale dhe ekipi të merr në telefon e ta gjen bashkë me ty.',
      price: 'Çmimi varet nga pjesa dhe shifra e saktë del te vetë pjesa. Zakonisht: <b>parakolp 250–350 €</b>, <b>body kit 450–800 €</b>, <b>conversion set 750–1200 €</b>.',
      pearl: '<b>E bardha perla</b> kërkon shtresë më shumë: <b>+60 €</b> te parakolpët dhe <b>+100 €</b> te body kitet e conversion set-et.',
      days: 'Afati: <b>parakolp 2–3 ditë</b>, <b>body kit ose conversion set 3–5 ditë</b> — duke filluar kur konfirmohet kodi dhe merret paradhënia, jo nga dita e porosisë.',
      pay: 'Pagesa e lyerjes bëhet veç: <b>50% paradhënie</b> para se të fillojë puna, 50% kur e merr.',
      noret: 'Dhe një gjë që duhet ta dish para se të vendosësh: <b>pas lyerjes pjesa nuk kthehet as ndërrohet</b> — bëhet vetëm për veturën tënde.',
      comes: 'Mund të vijë e lyer në ngjyrën e veturës sate — e lyejmë këtu sipas kodit, që të mos e kërkosh vetë lyerësin.',
      gloss: 'Këto nuk lyhen fare: difuzorët, spojlerat, lipat, splitterat, grillat dhe pragjet vijnë <b>gati në black gloss</b> nga fabrika — pa lyerje, pa pritje, pa kosto shtesë.',
      wa: 'Përshëndetje, dua ta di çmimin e lyerjes për ',
      waPlain: 'Përshëndetje, kam një pyetje për lyerjen.',
      waGloss: 'Përshëndetje, kam një pyetje për një pjesë.',
      waGlossLabel: 'Shkruaj ekipit',
      waLabel: 'Pyet ekipin për lyerjen'
    },
    en: {
      how: 'We paint the part ourselves, to your car\'s <b>factory colour code</b> — never by eye.',
      code: 'The code is on the sticker in the <b>right front door frame</b> (passenger side) — 2–4 characters, e.g. 475/9, LY9B, 197. If you can\'t find it, send 3–6 photos in daylight and the team will call you and find it with you.',
      price: 'The price depends on the part, and the exact figure is shown with the part itself. Typically: <b>bumper €250–350</b>, <b>body kit €450–800</b>, <b>conversion set €750–1200</b>.',
      pearl: '<b>Pearl white</b> needs an extra coat: <b>+€60</b> on bumpers and <b>+€100</b> on body kits and conversion sets.',
      days: 'Lead time: <b>bumper 2–3 days</b>, <b>body kit or conversion set 3–5 days</b> — counted from when the colour code is confirmed and the deposit is paid, not from the order date.',
      pay: 'Painting is invoiced separately: <b>50% deposit</b> before work starts, 50% when you collect it.',
      noret: 'One thing to know before you decide: <b>once painted, the part cannot be returned or exchanged</b> — it\'s made for your car only.',
      comes: 'It can come painted in your car\'s colour — we paint it here to the code, so you don\'t have to find a paint shop yourself.',
      gloss: 'These aren\'t painted at all: diffusers, spoilers, lips, splitters, grills and side skirts come <b>ready in black gloss</b> from the factory — no painting, no waiting, no extra cost.',
      wa: 'Hello, I\'d like the painting price for ',
      waPlain: 'Hello, I have a question about painting.',
      waGloss: 'Hello, I have a question about a part.',
      waGlossLabel: 'Message the team',
      waLabel: 'Ask the team about painting'
    },
    de: {
      how: 'Wir lackieren das Teil selbst, nach dem <b>Farbcode ab Werk</b> — nicht nach Augenmaß.',
      code: 'Der Code steht auf dem Aufkleber im <b>rechten vorderen Türrahmen</b> (Beifahrerseite) — 2–4 Zeichen, z.B. 475/9, LY9B, 197. Wenn du ihn nicht findest, schick 3–6 Fotos bei Tageslicht, das Team ruft dich an und findet ihn mit dir.',
      price: 'Der Preis hängt vom Teil ab, die genaue Zahl steht beim Teil selbst. Üblich: <b>Stoßstange 250–350 €</b>, <b>Body Kit 450–800 €</b>, <b>Conversion Set 750–1200 €</b>.',
      pearl: '<b>Perlweiß</b> braucht eine Schicht mehr: <b>+60 €</b> bei Stoßstangen und <b>+100 €</b> bei Body Kits und Conversion Sets.',
      days: 'Dauer: <b>Stoßstange 2–3 Tage</b>, <b>Body Kit oder Conversion Set 3–5 Tage</b> — ab Bestätigung des Farbcodes und Anzahlung, nicht ab Bestelldatum.',
      pay: 'Die Lackierung wird separat berechnet: <b>50% Anzahlung</b> vor Arbeitsbeginn, 50% bei Abholung.',
      noret: 'Eines noch, bevor du dich entscheidest: <b>nach der Lackierung ist keine Rückgabe oder ein Umtausch möglich</b> — das Teil wird nur für dein Auto gefertigt.',
      comes: 'Es kann in deiner Wagenfarbe lackiert kommen — wir lackieren hier nach Code, damit du keinen Lackierer suchen musst.',
      gloss: 'Diese werden gar nicht lackiert: Diffusoren, Spoiler, Lippen, Splitter, Kühlergrills und Seitenschweller kommen <b>fertig in Black Gloss</b> — keine Lackierung, kein Warten, keine Zusatzkosten.',
      wa: 'Hallo, ich möchte den Lackierpreis für ',
      waPlain: 'Hallo, ich habe eine Frage zur Lackierung.',
      waGloss: 'Hallo, ich habe eine Frage zu einem Teil.',
      waGlossLabel: 'Team anschreiben',
      waLabel: 'Team zur Lackierung fragen'
    }
  };

  function rule(t, lang) {
    if (!any(t, PAINT)) return null;
    var x = T[lang] || T.en;
    var wantsCode = any(t, CODE);
    var wantsPearl = any(t, PEARL);
    var wantsPrice = any(t, PRICE);
    var wantsTime = any(t, TIME);
    var wantsComes = any(t, COMES);
    var isGloss = any(t, GLOSS);
    var parts = [];

    if (isGloss) {
      parts.push(x.gloss);
      return { html: parts.join(' ') + glossTail(x), only: true };
    }

    if (wantsCode && !wantsPrice && !wantsTime) {
      parts.push(x.code);
      parts.push(x.how);
      parts.push(x.pay);
      parts.push(x.noret);
      return { html: parts.join(' ') + tail(x, ''), only: true };
    }

    if (wantsComes) parts.push(x.comes);
    else parts.push(x.how);

    if (wantsPrice || wantsPearl || (!wantsTime && !wantsCode)) parts.push(x.price);
    if (wantsPearl) parts.push(x.pearl);
    if (wantsTime || wantsPrice || wantsComes) parts.push(x.days);
    if (wantsCode) parts.push(x.code);
    parts.push(x.pay);
    parts.push(x.noret);
    if (isGloss) parts.push(x.gloss);

    return { html: parts.join(' ') + tail(x, ''), only: true };
  }

  function glossTail(x) {
    return '<p class="bacinext">' + waLink(x.waGloss, x.waGlossLabel) + '</p>';
  }

  function tail(x, what) {
    var msg = what ? (x.wa + what) : x.waPlain;
    return '<p class="bacinext">' + waLink(msg, x.waLabel) + '</p>';
  }

  window.BaciServiceRules.push(function (t, lang) {
    try { return rule(t, lang); } catch (e) { return null; }
  });
})();
